import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { resetPwd } from "../../services/ApiServices";
import logo from '../../assets/img/logo.png';

const ResetPassword = ({ setOpenResetPwd, email, otp, setLogin, setForgotEmailId, setOTP, forgotEmailId }: any) => {
    const [password, setPassword] = useState<string>("");
    const [confirmPwd, setConfirmPwd] = useState<string>("");
    const [confirmPwdError, setConfirmPwdError] = useState<boolean>(false);
    const [isLoading, setLoading] = useState(false);
    const validation = (e: any) => {
        e.preventDefault();
        if (!password) {
            toast.error("Please enter a password");
            return;
        }
        resetPasswordAPICall()
    }

    const resetPasswordAPICall = () => {
        resetPwd({ email: forgotEmailId, password: password, token: otp, password_confirmation: confirmPwd }).then((res) => {
            console.log("reset password", res);
            setLoading(true);
            if (res.status === "success") {
                toast.success(res.status)
                setOpenResetPwd(false);
                setLogin(true);
                setLoading(false);
                setForgotEmailId("");
                setOTP("");
            }
        }).catch((err) => {
            setLoading(false);
            console.log("forgot password error", err);
            toast.error("something went wrong");
        })
    }

    return (
        <div className="card border-0 rounded-4">

            <div className="simple-form">
                <div className="form-header text-center mb-5">
                    <h4 className="fs-2">Reset Password</h4>

                    <div className="effco-logo mb-2">
                        <Link className="d-flex align-items-center justify-content-center" to="/">
                            <img src={logo} height={50} width={"40%"} />
                        </Link>
                    </div>
                </div>
                <form>
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="form-group mb-3">
                                <label className='mb-2'>New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="New Password"
                                    value={password}
                                    name='email'
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <div className="form-group mb-3">
                                <label className='mb-2'>Confirm Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Confrm Password"
                                    value={confirmPwd}
                                    name='email'
                                    onChange={(e) => {
                                        setConfirmPwd(e.target.value)
                                        if (password !== e.target.value) {
                                            setConfirmPwdError(true)
                                        } else {
                                            setConfirmPwdError(false)
                                        }
                                    }}
                                />
                                {confirmPwdError ? <p style={{ color: "red" }}>Password Not Match.</p> : ""}
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary full-width fw-medium" onClick={(e) => validation(e)}>{isLoading ? "Updating..." : <>Update<i className="fa-solid fa-arrow-right-long ms-2"></i></>}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
